import { ChangeDetectorRef, Component, Input, ViewEncapsulation, ElementRef } from "@angular/core"

@Component({
    selector: "app-modal",
    template: ` <div
        [class]="
            'modal-dialog' +
            (size ? ' modal-' + size : '') +
            (scrollable ? ' modal-dialog-scrollable' : '')
        "
        role="document"
    >
        <div class="modal-content"><ng-content></ng-content></div>
    </div>`,
    encapsulation: ViewEncapsulation.None,
    host: {
        "[class]": '"modal" + (windowClass ? " " + windowClass : "")',
        role: "dialog",
        tabindex: "-1",
        style: "display: block",
    },
})
export class ModalComponent {
    @Input() public id: string
    @Input() size: string
    @Input() scrollable: string
    @Input() windowClass: string

    constructor(public changeDetectorRef: ChangeDetectorRef, public elementRef: ElementRef) {}
}
